export const MAX_IMAGE_BYTES = 6 * 1024 * 1024;
export const IMAGE_ACCEPT = '.jpg,.jpeg,.png,.gif,.webp';

export const isImageFile = (file) => /\.(jpe?g|png|gif|webp)$/i.test(file.name);

export const readImage = async (file) => {
  if (!isImageFile(file)) throw new Error('仅支持 JPG、PNG、GIF、WebP 图片');
  if (!file.size || file.size > MAX_IMAGE_BYTES) {
    throw new Error('图片不能为空，单张及本次图片合计不能超过 6MB');
  }
  const rawDataUrl = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('图片读取失败，请重新选择'));
    reader.readAsDataURL(file);
  });
  const extension = file.name.split('.').pop().toLowerCase();
  const mime = extension === 'jpg' ? 'jpeg' : extension;
  const dataUrl = rawDataUrl.replace(/^data:[^;]*;/, `data:image/${mime};`);
  await new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => {
      if (image.naturalWidth > 4096 || image.naturalHeight > 4096) {
        reject(new Error('图片长边不能超过 4096 像素，请缩小后上传'));
      } else {
        resolve();
      }
    };
    image.onerror = () => reject(new Error('图片无法打开，请检查文件是否损坏'));
    image.src = dataUrl;
  });
  return dataUrl;
};

export const buildUserContent = (question, files = []) => {
  const readyFiles = files.filter((file) => file.status === 'done');
  const documents = readyFiles.filter((file) => !file.imageUrl);
  const images = readyFiles.filter((file) => file.imageUrl);
  const fileText = documents.map((file) =>
    `[文件: ${file.filename}]\n${file.content.substring(0, 10000)}`,
  ).join('\n\n');
  const text = fileText
    ? `以下是用户上传的文件内容，请在回答用户问题时参考这些内容：\n\n${fileText}\n\n用户问题：${question}`
    : question;
  return images.length
    ? [{ type: 'text', text }, ...images.map((file) => ({
      type: 'image_url', image_url: { url: file.imageUrl },
    }))]
    : text;
};

export const getMessageImages = (content) => Array.isArray(content)
  ? content.filter((item) => item?.type === 'image_url' && item.image_url?.url)
    .map((item) => item.image_url.url)
  : [];
